import React from 'react'
import { Link } from 'react-router-dom'
import { config } from '../config'
import { slugGenerator } from '../../../utils/slugGenerator'
import moment from 'moment'

const NewsCard = ({ news }) => {
    return (
        <div>
            {news?.map((blog, i) => {
                return (
                    <div className="col-lg-12 mb-50" key={i + 1}>
                        <div className="blog-item">
                            <div className="blog-img">
                                <Link to={`${config.appUrl}news/${blog.slug}`} >
                                    <img src={blog?.imageUrl} alt="" /></Link>
                                <ul className="post-categories">
                                    <li><Link to={`${config.appUrl}news/${blog.slug}`} >{blog?.category}</Link></li>
                                </ul>
                            </div>
                            <div className="blog-content">
                                <h3 className="blog-title">
                                    <Link to={`${config.appUrl}news/${blog.slug}`} >
                                        {blog?.title}
                                    </Link>
                                </h3>
                                <div className="blog-meta">
                                    <ul className="btm-cate" style={{listStyle:"outside none"}}>
                                        <li>
                                            <div className="blog-date">
                                                <i className="bi bi-calendar-event"></i> {moment(blog?.created_at).format("MMMM D , YYYY")}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="author">
                                                <i className="bi bi-person"></i>Admin
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div className="blog-desc" dangerouslySetInnerHTML={{__html : blog?.description.split('.')[0]}}>
                                </div>
                                <div className="blog-button">
                                    <Link to={`${config.appUrl}news/${blog.slug}`} className="blog-btn" >Continue Reading <i className='bi bi-arrow-right'></i></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}

        </div>
    )
}

export default NewsCard
